import client from '@lib/core/axios.client';
import { API_ENDPOINTS } from '@lib/constants';
import type {
  AdminWhatsAppBusinessFlowDiagnosticRequest,
  WhatsAppBusinessFlowDiagnosticResponseDto,
} from '@/types/api/admin';

export class AdminWhatsAppFlowDiagnosticsService {
  private static instance: AdminWhatsAppFlowDiagnosticsService;

  private constructor() {}

  public static getInstance(): AdminWhatsAppFlowDiagnosticsService {
    if (!AdminWhatsAppFlowDiagnosticsService.instance) {
      AdminWhatsAppFlowDiagnosticsService.instance = new AdminWhatsAppFlowDiagnosticsService();
    }

    return AdminWhatsAppFlowDiagnosticsService.instance;
  }

  async diagnose(
    request: AdminWhatsAppBusinessFlowDiagnosticRequest
  ): Promise<WhatsAppBusinessFlowDiagnosticResponseDto> {
    return await client.post<WhatsAppBusinessFlowDiagnosticResponseDto>(
      API_ENDPOINTS.ADMIN.WHATSAPP_BUSINESS.FLOW_DIAGNOSTICS,
      request
    );
  }
}

export const adminWhatsAppFlowDiagnosticsService = AdminWhatsAppFlowDiagnosticsService.getInstance();
export default adminWhatsAppFlowDiagnosticsService;
